import { render, staticRenderFns } from "./CommentActions.vue?vue&type=template&id=52f4b4d8&scoped=true&"
import script from "./CommentActions.vue?vue&type=script&lang=js&"
export * from "./CommentActions.vue?vue&type=script&lang=js&"
import style0 from "./CommentActions.vue?vue&type=style&index=0&id=52f4b4d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4b4d8",
  null
  
)

export default component.exports